export default ($) => {
	let loadVideo = $('.video-thumbnail');

	loadVideo.click(function() {
		let thumbID = this.id;
		dispKalturaPlayer(thumbID);
	});

	function dispKalturaPlayer(thisSelector) {
		let thisSelectorID = '#' + thisSelector;
		let containerID = '#' + $(thisSelectorID).data('vid-container');
		let mediaVal = $(thisSelectorID).data('media');
		let widgetVal = $(thisSelectorID).data('widget');
		let playlistVal = $(thisSelectorID).data('playlist');
		let autoplayVal = $(thisSelectorID).data('autoplay');

		if (containerID === thisSelectorID) {
			thisSelectorID.classList.add('hide-play-btn');
		}

		let closebtn = $('.close-image-btn');
		closebtn.click(function() {
			$(containerID).html('');
		});
		$.ajax({
			type : 'post',
			dataType : 'html',
			data : {
				action : 'load_video',
				media : mediaVal,
				widget : widgetVal,
				playlist : playlistVal,
				autoplay : autoplayVal
			},
			url : wp_params.ajaxurl,
			success : function(rd) {
				$(containerID).html(rd);
			},
			error : function(MLHttpRequest, rd, errorMsg) {
				console.log(errorMsg);
			}
		});
	}
}